<template>
<b-container class="animated fadeIn pt-0 posContainer">
	<!--<div class="actions">-->
	<!--&lt;!&ndash;<div class="" id="posBackButton">-->
	<!--<b-link to="../" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('Back') }}</b-link>-->
	<!--</div>&ndash;&gt;-->
	<!--&lt;!&ndash;<div class="clearfix"></div>&ndash;&gt;-->
	<!--</div>-->
	<b-row class="posRow hidden-print">
		<!-- LEFT PART: POS TERMINAL -->
		<b-col cols="9" id="pos-col-left" class="pr-0 pl-0">
			<!-- CARD-FOR-POS CHILD COMPONENT -->
			<card-for-pos :suspend-active="suspendActive" :header-title="shopName + ' (' + shopAddress + ', ' + userDepCurrencyName + ') '" :sale-number="currentSaleNumber" @searchBarFocus="focusSearchBar" @changeSuspendActive="changeSuspendActive"
			  @newPosOpened="focusSearchBar">
				<!-- THIS GOES INSIDE DEFAULT SLOT -->
				<b-col>
					<form @submit="e => e.preventDefault()">
					<b-input-group>
						<b-input-group-text slot="prepend"  :style="[isReturn ? {'border-color': 'red'} : {}]">
							<span class="input-group-addon">
								<i class="fa fa-barcode"></i>
							</span>
						</b-input-group-text>

							<b-form-input class="form-control mousetrap ui-autocomplete-input"
							 id="search_product" ref="searchBar" :placeholder="isReturn ? $t('pos.search-item-return')
								: $t('pos.search-item')" @input="filterChanged"
								v-model="posSearchValue" onClick="setSelectionRange(0, value.length)"
								autocomplete='off'
								name="search_product" type="text"

								:style="[isReturn ? {'border-color': 'red'} : {}]"></b-form-input>
						<!-- PRODUCT SEARCH RESULT -->
						<div id="searchResult" ref="searchResult" v-click-outside="hideSearchResult" :style="[getItems.length > 0 ? {'min-height': 'unset'} : {}]">

							<with-keyboard-control-for-pos :listLength="getItems.length" @selected="selectedHandler" @escapeClicked="escapeClicked" :current-index="computedCurrentIndex" ref="withKeyboardControl">
								<template slot-scope="{selectedIndex}">
									<loading v-if="searchLoading" width="60px" height="60px"></loading>
									<template v-if="getItems.length > 0 && !searchLoading">
										<div v-for="(item, index) in getItems" class="d-flex justify-content-between foundProduct align-items-center"
											:class="{'selected': index === selectedIndex, 'disabled': (item.qty <= 0 || !item.qty || item.priceWholesale <= 0) && !isReturn
											}" :key="'searchItem' + index"
											@click="selectedHandler(index)"
											:style="[item.isPriceDifferent ? {'background-color': '#fff7ae'} : {}]">
											<template>
												<div class="productName mb-0 d-flex">
													<div>
														{{ index + 1 }}.
													</div>
													<div>
														<img class="posItemImage" :src="item.mainPhotoId ? imageUrl + item.mainPhotoId : `${publicPath}img/pos-images/default-thumbnail.jpg`" alt="itemImage">
													</div>
													<div>
														<span :style="[item.wrapped ? {'color': 'blue'} : {'color': 'black'}]">
															<b v-if="item.wrapped">{{$t('sack')}}</b> {{ item.name ? item.name : '' }} / <strong>{{ item.artikul }}</strong> / {{ item.colorName }} / <strong>{{ item.size }}</strong>
														</span>
													</div>

												</div>
											</template>

											<template>
												<div class="productPrice">
													<p>
														<strong>Цена:</strong>
														<span :style="[item.priceWholesale < 0 ? {'color': 'red'} : {'color': 'green'}]">
															{{ item.priceWholesale | currency({
																symbol:
																	userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
															}) }}
														</span>
														<span id="incomeDateOfItem" v-if="item.isPriceDifferent && item.incomeDates.length > 0" :title="makeTooltipForPrice(item.incomeDates)">
															<strong>
																<i>{{ item.incomeDates.length > 1 ? item.incomeDates[item.incomeDates.length - 1].substring(0,7) + '(' + item.incomeDates.length + ')' : item.incomeDates[0].substring(0,7) }}</i>
															</strong>
														</span>
													</p>
													<p>
														<strong>Кол-во:</strong>
														<span :style="[item.qty > 0 ? {'color': 'blue'} : {'color': 'red'}]">
															{{ item.qty ? item.qty : 0 }} {{ item.unitName ? item.unitName : 'шт.'}}
														</span>
													</p>
												</div>
												<p class="productBreadcrumb">
													{{ item.subCategoryName }} / {{ item.sub2CategoryName }} / {{
														item.sub3CategoryName }} / <strong>{{ item.genderName }}</strong>
												</p>
											</template>
										</div>
									</template>
									<p v-if="getItems.length == 0 && !searchLoading" style="padding: 10px;">
										{{ $t('warehouse.document.itemNotFound') }}
									</p>
								</template>
							</with-keyboard-control-for-pos>
						</div>


						<b-input-group-text slot="append" id="for-barcode" :style="[isReturn ? {'border-color': 'red', 'cursor': 'pointer'} : {'cursor': 'pointer'}]">
							<b-input-group-addon style="cursor: pointer;" class="input-group-addon barcode-refresh" @click="searchBarRefresh">
								<i class="fa fa-refresh"></i>
							</b-input-group-addon>
						</b-input-group-text>

					</b-input-group>
					</form>
				</b-col>
				<!-- THIS GOES INSIDE ITEMS SLOT -->
				<template v-slot:items>
					<b-col>
						<div id="posProducts" class="table-wrapper">
							<b-table small hover bordered striped :fields="fields" :items="getCartItems"
							 				class="generalTableClass posProductsTable" show-empty
											>
								<!-- EMPTY SLOT FOR TABLE -->
								<template slot="empty">
									<h5 style="text-align: center;">{{ $t('emptyTxtForPosTable') }}</h5>
								</template>
								<!-- EMPTY SLOT FOR TABLE -->
								<template slot="number" slot-scope="data">
									{{ data.index + 1 }}
								</template>

								<template slot="artikul" slot-scope="data">
									<b v-if="data.item.wrapped" style="color: blue; font-weight: bold; font-size: 13px;">{{$t('sack')}} - </b>
									{{data.item.name ? data.item.name : '' }} / <strong>{{ data.item.artikul
										}}</strong> / {{ data.item.colorName }} / <strong>{{ data.item.size }}</strong>
								</template>

								<template slot="quantity" slot-scope="data">
									<b-input-group size="sm" class="posQtyButton">
										<b-input-group-prepend>
											<b-button variant="secondary" size="sm" @click="decreaseQty(data.index)" :disabled="isCountBtnsDisabled">
												-
											</b-button>
										</b-input-group-prepend>

										<b-form-input type="number" min="1" autocomplete="off"
										:value="getCountOfItem(data.index)"
										 @input="setCount($event, data.index)" @keyup.enter.native="focusSearchBar"
										  @focus="$event.target.select()"></b-form-input>

										<b-input-group-append>
											<b-button variant="success" size="sm" @click="increaseQty(data.index)" :disabled="isCountBtnsDisabled">
												+
											</b-button>
										</b-input-group-append>
									</b-input-group>
									<!-- OMBORDAGI QOLDIQDAN KO'P KIRITVORSA CHIQADI BU YOZUV -->
									<p v-if="getCountOfItem(data.index) > data.item.qty && !data.item._rowVariant" style="color: red;">
										Доступно только {{ data.item.qty }} {{ data.item.unitName ?
											data.item.unitName : 'шт.'}}
									</p>
								</template>

								<template slot="priceWholesale" slot-scope="data">
									{{ data.item.priceWholesale | currency({symbol: saleCurrencyName, fractionCount: 2,
										symbolPosition: 'back'}) }}
								</template>

								<template slot="pul" slot-scope="data">
									{{ afterPromotionSum(data.item) | currency({
										symbol:
										saleCurrencyName, fractionCount: 2, symbolPosition: 'back'
										}) }}
								</template>
								<template slot="percentage" slot-scope="data">
									{{ afterPromotionPercentage(data.item) | currency({
										symbol:
										'%', symbolPosition: 'back'
										}) }}
								</template>
								<template slot="discountPriceUzs" slot-scope="data">
									{{data.item.discountPriceUzs | currency({
										symbol: saleCurrencyName, fractionCount: 2, symbolPosition:
										'back'
										}) }}
								</template>

								<template slot="subtotal" slot-scope="data">
									{{ data.item.discountPriceUzs * data.item.count | currency({
										symbol:
										saleCurrencyName, fractionCount: 2,
										symbolPosition: 'back'
										})}}
								</template>

								<template slot="inventoryQty" slot-scope="data">
									{{ data.item.qty }} {{ data.item.unitName ? data.item.unitName : 'шт.'}}
								</template>

								<template slot="actions" slot-scope="data">
									<b-link :key="data.item.id + 'delete'" @click="deleteFromCart(data.index)">
										<i class="fa fa-trash"></i>
									</b-link>
									<b-link :key="data.item.id + 'update'" @click="openItemForDiscount(data, data.index)">
										<i class="fa fa-pencil-square-o cursor-pointer"></i>
									</b-link>
								</template>
							</b-table>
							<div v-if="loadingForPosTable" class="spinner-wrapper">
								<b-spinner variant="primary"></b-spinner>
							</div>
						</div>
					</b-col>

					<!-- OVERALL AND BUTTONS PART -->
					<b-col style="position:absolute; bottom: 0;" class="pl-0">
						<div id="overallAndButtons">
							<table class="table table-condensed posFooterTable">
								<tbody>
									<tr>
										<td style="display: flex; align-items: center;" class="pl-3">
											<b-col class="d-inline-table" col sm="2" xs="2">
												<b>{{$t('incomes.create.product')}}: </b> <br>
												<span>{{totalCount}}</span>
											</b-col>
											<b-col class="d-inline-table" col sm="2" xs="2">
												<b>{{$t('pos.no-skidka')}}: </b> <br>
												<span>{{ setBezSkidkaSum | currency({symbol: saleCurrencyName, fractionCount: 2, symbolPosition: 'back'})
													}}</span>
											</b-col>
											<b-col class="d-inline-table" col sm="2" xs="2">
												<b>{{$t('pos.sum')}}: </b> <br>
												<span>{{ setTotalSum | currency({symbol: saleCurrencyName, fractionCount: 2, symbolPosition: 'back'})
													}}</span>
											</b-col>

											<b-col class="d-inline-table" col sm="2" xs="2">
												<b>{{ $t('pos.discountForEachItem') }}: </b> <br>
												<i @click="openModalForOptomDiscount" style="padding-right: 5px" class="fa fa-pencil-square-o cursor-pointer" id="pos-edit-optom-discount" title="Edit Discount" aria-hidden="true"
												  data-toggle="modal"></i>
												<span>{{ discountOptom !== null ? discountOptom : "0.00" }}</span>
											</b-col>

											<b-col class="d-inline-table" col sm="2" xs="5">
												<div class="lastElemet">
													<div>
														<b>{{$t('pos.finalTotalSum')}}: </b> <br>
														<strong style="color: green;font-size: 14px">
															{{finalTotalSum | currency({
															symbol: saleCurrencyName, fractionCount: 2,
															symbolPosition: 'back'
															}) }}</strong>
													</div>
												</div>
											</b-col>
											<b-col class="d-inline-table" col sm="1" xs="1">
												<div class="d-flex justify-content-end mr-3">
													<b-button variant="danger" style="padding: 0 5px; font-size: 12px;" @click="cancelClicked">
														{{$t('cancel')}}
													</b-button>
												</div>
											</b-col>
										</td>
									</tr>
									<tr>
										<td id="posButtons">
											<div class="d-flex align-items-center col-6" style="height: 50px">
												<div class="col-6 pl-0">
													<b-form-textarea style="height: 50px;" id="textarea" :value="comment" @input="commentForSuspend" :placeholder="$t('comment')" rows="3" max-rows="6"></b-form-textarea>
												</div>

												<b-col class="d-inline-table" col sm="2" xs="2">
													<b-button variant="warning" @click="saveSuspend" style="width: 92%; height: 50px">
														<i class="fa fa-pause"></i>
													</b-button>
												</b-col>
											</div>

											<b-col class="d-inline-table" col sm="3" xs="3" v-if="getPriceChanged.boolean">
												<b-button variant="info"
														  style="width: 92%; height: 50px; font-size: 18px;"
															@click="showLatestPricesModal"
												>
													<i class="fa fa-refresh"></i> {{ $t('pos.latestPricesButtonTxt') }}
												</b-button>
											</b-col>
											<b-col class="d-inline-table" col sm="3" xs="3">
												<b-button @click="multiplePayment" variant="success" ref="paymentButton" style="width: 95%; height: 50px; font-size: 24px;">
													{{$t('pos.payment')}}
												</b-button>
												<b-modal size="lg" hide-footer ref="multiPayModal" id="posPaymentModal">
													<div slot="modal-header" class="posCustomModalHeader">
														<h1 class="modal-title">Оплата</h1>
														<span v-if="saleFinishError" class="modal-title">{{ saleFinishError }}</span>
														<b-spinner v-if="saleFinishLoading" small variant="primary" label="Small Spinner"></b-spinner>
														<!--														<button class="modal-actions">button</button>-->
														<div class="posModalActions d-flex">

															<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePayment">
																<!--																<span aria-hidden="true">&times;</span>-->
																<i class="fa fa-times"></i>
															</button>
														</div>
													</div>
													<!-- MULTIPLE PAYMENT COMPONENT BEGIN -->
													<multiple-pay :totalCount="totalCount" :totalSum="finalTotalSum" :saleCurrencyName="saleCurrencyName" :openClicked="openClicked" @close="closePayment" @success="successMultiPay"
													  @hidden="focusSearchBar">
													</multiple-pay>
													<!-- MULTIPLE PAYMENT COMPONENT END -->
												</b-modal>


											</b-col>

										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</b-col>
				</template>
			</card-for-pos>
		</b-col>

		<div id="aside" class="col-3 pr-0">
			<b-card bg-variant="white" class="forHeader posClientWholesale" body-class="cardBodyClass">
				<div slot="header" class="custom-card-header d-flex justify-content-end">
					<div class="col-md-6 posSessionButtons">
						<div class="">
							<b-button @click="showXReport()"
									  variant="success"
									  v-b-tooltip.hover title="X отчет"
							>
								<strong>
									<i class="fa fa-window-close"></i>
								</strong>
							</b-button>
							<b-button
								@click="showConfirmEndSession()"
								variant="danger"
								v-b-tooltip.hover title="Закрыть сеанс"
							>
								<strong>
									Z<!--<i class="fa fa-window-close"></i>-->
								</strong>
							</b-button>

						</div>
					</div>
					<b-button class="close-btn p-0" @click="cancelAndClearInventory" type="button" variant="link">
						<i class="fa fa-close"></i>
					</b-button>
				</div>
				<b-row style="flex-direction: row">
					<b-col cols="12">
							<b-form-group label-cols="2" label-cols-lg="6" label-size="sm"
										  :label="$t('wholesale.currencyCheckboxLabel')"
										  label-for="currencyCheckbox">
								<b-row class="my-1">
									<b-col sm="12">
										<b-checkbox v-model="currencyCheckbox" id="currencyCheckbox"></b-checkbox>
									</b-col>
								</b-row>
							</b-form-group>
						</b-col>
					<b-col cols="12">
						<b-form-group v-if="currencyCheckbox" label-cols="4" label-cols-lg="3" label-size="sm" :label="$t('department.money-type')+':'" label-for="saleCurrency">
							<b-form-select v-model="saleCurrency"
							:plain="false" :options="refCurrencies"
							size="sm" id="saleCurrency" :text-field="'name'" :value-field="'id'">
								<template slot="first">
									<option :value="null" disabled>{{$t('department.money-type-department')}}
									</option>
								</template>
							</b-form-select>
						</b-form-group>
					</b-col>

					<template v-if="currencyCheckbox">
						<!--CURRENCY RATE INPUTS FOR TRANSFER BEGIN -->
						<!--SHOW WHEN TOGGLE IS FALSE-->
						<template v-if="isCurrenciesDifferent && !toggleCurrencyInputs">
							<b-col cols="12">
								<b-form-group breakpoint="lg" label-size="sm" label-cols="12" :label="$t('kochirish.currencyRate')" label-for="fromCurrencyRateId" label-class="" class="required">
									<b-input-group size="sm">
										<b-form-input size="sm" ref="toCurrencyRateRef2" id="toCurrencyRateId" @focus="$event.target.select()" type="number" v-model.number="saleCurrencyRate" class="" :disabled="!toggleCurrencyInputs"
										  :placeholder="makeSaleCurrencyName(saleCurrency)"></b-form-input>
										<b-input-group-addon>
											<b-button disabled size="sm" v-if="saleCurrency">{{
													makeSaleCurrencyName(saleCurrency) }}
											</b-button>
										</b-input-group-addon>
									</b-input-group>
								</b-form-group>
							</b-col>
							<b-col cols="12" style="text-align: center" class="mb-1 mt-1">
								<b-button @click="toggleCurrencyInputs = !toggleCurrencyInputs" size="md" class="mr-3">
									<i class="fa fa-exchange"></i>
								</b-button>
								<b-button variant="primary" class="px-4" @click="savePos('forConvert')">
									{{ $t('wholesale.convertButton') }}
								</b-button>
							</b-col>
							<b-col cols="12">
								<b-input-group size="sm" class="p-0">
									<b-form-input size="sm" ref="fromCurrencyRateRef2" id="fromCurrencyRateId" @focus="$event.target.select()" type="number" v-model.number="depCurrencyRate" class="" :placeholder="userDepCurrencyName"></b-form-input>
									<b-input-group-addon>
										<b-button disabled size="sm">{{ userDepCurrencyName }}</b-button>
									</b-input-group-addon>
								</b-input-group>
							</b-col>
						</template>
						<!--SHOW WHEN TOGGLE IS TRUE-->
						<template v-if="isCurrenciesDifferent && toggleCurrencyInputs">
							<b-col cols="12">
								<b-form-group breakpoint="lg" label-size="sm" label-cols="12" :label="$t('kochirish.currencyRate')" label-for="toCurrencyRateId" label-class="" class="required">
									<b-input-group size="sm" class="p-0">
										<b-form-input size="sm" ref="fromCurrencyRateRef1" id="fromCurrencyRateId" @focus="$event.target.select()" type="number" v-model.number="depCurrencyRate" class="" :disabled="toggleCurrencyInputs"
										  :placeholder="userDepCurrencyName"></b-form-input>
										<b-input-group-addon>
											<b-button disabled size="sm">{{ userDepCurrencyName }}</b-button>
										</b-input-group-addon>
									</b-input-group>
								</b-form-group>

							</b-col>
							<b-col cols="12" style="text-align: center" class="mb-1 mt-1">
								<b-button @click="toggleCurrencyInputs = !toggleCurrencyInputs" size="md" class="mr-3">
									<i class="fa fa-exchange"></i>
								</b-button>
								<b-button variant="primary" class="px-4" @click="savePos('forConvert')">
									{{ $t('wholesale.convertButton') }}
								</b-button>
							</b-col>
							<b-col cols="12">
								<b-input-group size="sm">
									<b-form-input size="sm" ref="toCurrencyRateRef1" id="toCurrencyRateId" @focus="$event.target.select()" type="number" v-model.number="saleCurrencyRate" class="" :placeholder="makeSaleCurrencyName(saleCurrency)">
									</b-form-input>
									<b-input-group-addon>
										<b-button disabled size="sm" v-if="saleCurrency">{{
												makeSaleCurrencyName(saleCurrency) }}
										</b-button>
									</b-input-group-addon>
								</b-input-group>

							</b-col>
						</template>
						<!--CURRENCY RATE INPUTS FOR TRANSFER END-->
					</template>

					<!--<b-col cols="12" v-if="selectContrAgent">
						<p class="text-danger">Пожалуйста выберите контрагента</p>
					</b-col>-->
					<b-col cols="12 mt-5">
						<b-form-group label-size="sm" label-cols="12"
							 class="mb-2 mt-2" size="sm">
							 <span style="font-size: 12px;margin-bottom: 5px;
    			 			display: block;">{{$t('incomes.create.counteragent')+ ':'}}
								<b class="ml-2 text-success"
									v-if="contrAgent && !contragentSaldoError.boolean">{{contragentSaldo | currency({
										symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
										thousandsSeparator: ' '
										})}}</b>
									<b class="text-warning ml-1" v-if="contrAgent && contragentSaldoError.boolean">
										{{$t('pos.get-error-saldo')}}
									</b>
								</span>
							<b-input-group class="shodowed-group">
								<b-form-select @change="categoryFilterChanged"
								:options="categoryOptions.items" :value-field="'id'" :text-field="'name'"
								v-model="categoryOptions.value" size="sm" id="categoryFilter">
									<template slot="first">
										<option :value="null" disabled>
											-- {{$t('contragent.search-category')}} --
										</option>
									</template>
								</b-form-select>
								<b-input-group-append>
									<b-input-group-addon>
										<b-button type="button" size="sm" variant="outline-default" @click="clearCategoryFilter" v-b-tooltip.hover :title="$t('contragent.clear')">
											<i class="fa fa-close"></i>
										</b-button>
									</b-input-group-addon>
								</b-input-group-append>
							</b-input-group>
						</b-form-group>
					</b-col>
					<b-col cols="12">
						<b-form >
						<multiselect v-model="contrAgent"
						 :options="getContragentsForPos"
						  track-by="id" :show-labels="false"
							:allow-empty="true" :loading="contragentsLoading"
							label="fullName" placeholder="--Выберите контрагента--"
							:searchable="categoryOptions.value? true : false"
						  class="multiselect-pricing"
							>
						</multiselect>
					</b-form >
					</b-col>
					<b-col cols="12" style="margin-top: 60px;">
						<div id="returnComponentButton">
							<b-button pill v-b-tooltip.hover @click="openReturnComponentModal">
								{{$t('pos.return')}}
							</b-button>
						</div>
					</b-col>
					<b-col cols="12" class="mt-2">
						<div id="bookingDocsButton">
							<b-button pill @click="openBookingDocsModal" variant="primary">
								{{ $t('booking.bookings') }}
							</b-button>
						</div>
					</b-col>
				</b-row>
			</b-card>
			<div style="display: flex; min-height: 0%; transition: min-height .25s ease-out;" :class="transactionCollapsed ? 'takeMinHeight' : ''">
				<b-card style="min-height: 100%; width: 100%; margin-bottom: 0;">
					<div style="display: flex;justify-content: space-between;cursor: pointer">
						<i @click="suspendModal" class="fa fa-info-circle fa-lg"></i>
						<span>{{$t('pos.sale-prev')}}</span>
						<i  @click="transactionCollapsed = !transactionCollapsed" v-if="transactionCollapsed" class="fa fa-lg fa-minus" style="align-items: center;display: flex"></i>
						<i  @click="transactionCollapsed = !transactionCollapsed" v-else class="fa fa-lg fa-plus" style="align-items: center;display: flex"></i>
					</div>
					<b-collapse id="collapse-1" v-model="transactionCollapsed" class="mt-2">
						<!-- TEST  -->
						<b-tabs content-class="customTabContent" fill>

							<b-tab :title="$t('pos.sale-title')" title-link-class="customTabLink" active>
								<b-table style="max-width: 400px ;white-space: nowrap" class="generalTableClass generalTableClassForSuspend" responsive="sm"
								  :items="latestSuspends" :fields="computedFields" :per-page="0" show-empty>
									<!-- EMPTY SLOT FOR TABLE -->
									<template slot="empty">
										<h6>{{ $t('empty') }}</h6>
									</template>
									<!-- EMPTY SLOT FOR TABLE -->
									<template slot="actions" slot-scope="data">
										<b-link :key="data.item.id + 'delete'" @click="onOpen(data.item.id)" :id="'popOverDelete'+data.item.id" v-if="$can('delete', 'employee')">
											<i class="fa fa-trash"></i>
										</b-link>

										<b-link class="suspendEditButton" @click="updateDraft(data.item)" v-b-tooltip.hover :disabled="disableSuspendButton">
											<i class="fa fa-edit"></i>
										</b-link>

										<b-popover :key="data.item.id + 'popover'" :target="'popOverDelete'+data.item.id" placement="auto" container="myContainer" :ref="'popover'+data.item.id" class="refDeleteConfirm">
											<template slot="title">
												<b-button @click="onClose(data.item.id)" class="close" aria-label="Close" style="margin-left: 5px">
													<span class="d-inline-block" aria-hidden="true">&times;</span>
												</b-button>
												Вы уверены?
											</template>
											<div>

												<div class="row mt-1">
													<div class="col-6">
														<b-button variant="outline-danger" size="sm" block @click="onClose(data.item.id)">{{$t('actions.no')}}
														</b-button>
													</div>
													<div class="col-6">
														<b-button variant="outline-success" size="sm" block @click="onOk(data.item.id)">{{$t('actions.yes')}}
														</b-button>
													</div>
												</div>
											</div>
										</b-popover>


									</template>


								</b-table>
							</b-tab>
							<!--						<b-tab title="Tugallangan" title-link-class="customTabLink"><p>I'm the first tab</p></b-tab>-->
						</b-tabs>

					</b-collapse>
				</b-card>

			</div>
		</div>
		<b-modal
			v-model="returnComponentModal"
			size="lg"
			hide-footer
			hide-header
			:no-close-on-esc="true"
			:no-close-on-backdrop="true"
		>
			<template>
				<return-component :mode="'wholesale'" @close="closeModalWindow('returnComponentModal')" :showReturnModal="returnComponentModal"></return-component>
			</template>

		</b-modal>
		<b-modal hide-footer v-model="discountOpenModal" @shown="focusMyDiscount" :title='discountTForTitle? `Скидка на ${saleItemForDiscountModal.item.name}`: "Скидка на чек"'>
			<pos-discount @emitClose="closeEmit" @saveSuccess="savePos('draft')" :itemIndex="currentItemIndex" ref="posDiscount"></pos-discount>
		</b-modal>
		<b-modal hide-footer v-model="discountOptomOpenModal" @shown="focusMyOptomDiscount" :title='`Оптом скидка`'>
			<pos-discount-optom @emitClose="closeOptomDiscount" @saveSuccess="saveOptomDiscount" ref="posOptomDiscount" :canceled="getCartItems.length === 0 || discountOptom === null"></pos-discount-optom>
		</b-modal>
		<b-modal size="md" hide-footer ref="sessionStart" id="sessionStart" :no-close-on-esc="true" :no-close-on-backdrop="true" @shown="focusEnterCode">
			<div slot="modal-header" class="d-flex justify-content-start align-items-center">
				<b-link to="/" variant="outline-dark" class="mr-3" v-b-tooltip.hover :title="$t('sidebar.dashboard')">
					<i class="fa fa-home" style="font-size: 18px;"></i>
				</b-link>
				<h1 class="modal-title">Начало Сессии: Код 12345</h1>
			</div>
			<h3 v-if="sessionStart.isFail" class="text-danger">{{sessionStart.message}}</h3>

			<b-form-group :state="sessionStart.codeState" label="Код" label-for="name-input" invalid-feedback="Пожалуйста, введите правильный код">
				<b-form-input ref="enterConfirmCode" size="md" autocomplete="off" class="form-control mousetrap ui-autocomplete-input" id="name-input" v-model="sessionStart.code" required></b-form-input>
			</b-form-group>


		</b-modal>

		<!-- MODAL FOR SETTING LATEST PRICES -->
		<b-modal v-model="latestPricesModal" @ok="setLatestPricesForSale" @cancel="latestPricesModal = !latestPricesModal" ok-title="Да" cancel-title="Отмена">
			<h4>{{ $t('pos.setLatestPricesTxt') }}</h4>
		</b-modal>

		<b-modal v-model="confirmEndSession" @ok="showZReport" @cancel="confirmEndSession = !confirmEndSession" ok-title="Да" cancel-title="Отмена">
			<h4>Вы уверены, что хотите закрыть сессию?</h4>
		</b-modal>
		<b-modal size="lg" hide-footer :no-close-on-esc="true" :no-close-on-backdrop="true" hide-header ref="zreport" id="zreport">
			<!-- ZET REPORT COMPONENT BEGIN -->
			<zet-report v-if="zreport" @close="closeZreport"></zet-report>
			<!-- ZET REPORT  COMPONENT END -->
		</b-modal>
		<b-modal size="lg" hide-footer hide-header ref="xreport" id="xreport">
			<!-- X REPORT COMPONENT BEGIN -->
			<x-report v-if="xreport" @close="closeXreport"></x-report>
			<!-- X REPORT  COMPONENT END -->
		</b-modal>
		<!-- Suspend Modal BEGIN -->
		<b-modal size="xl" hide-footer ref="suspendModal" >
			 <b-table class="generalTableClass" striped hover  :items="latestSuspends" :fields="computedFieldsModal" >
				 <template slot="excel" slot-scope="data">
					 <b-link @click="fetchData(data.item)">
						 <i class="fa fa-eye fa-lg"></i>
					 </b-link>
				 </template>
			</b-table>
			<b-modal size="xl" hide-footer ref="suspendModalItems" >
				<loading v-if="fetchLoading" width="60px" height="60px"></loading>
				<download-excel v-if="!fetchLoading"
					size="sm"
					class="btn btn-success"
					:data="itemsForExcel"
					worksheet="My Worksheet"
					name="Excel">
				</download-excel>
				<!-- <b-button
					variant="outline-primary"
					@click="tableToExcel('tableForExcel', 'test')"
					class="mr-2"
				>
					{{ $t('excel-export.download-excel') }}
				</b-button> -->
			 <b-table v-if="!fetchLoading"  small hover bordered striped :items="itemsForExcel"
			 id="tableForExcel"
			  class="generalTableClass posProductsTable mt-1">
								<template slot="number" slot-scope="data">
									{{ data.index + 1 }}
								</template>

								<template slot="Продукт" slot-scope="data">

									<b v-if="data.item.wrapped" style="color: blue; font-weight: bold; font-size: 13px;">{{$t('sack')}} - </b>
									{{data.item.name ? data.item.name : '' }} / <strong>{{ data.item.artikul
										}}</strong> / {{ data.item.colorName }} / <strong>{{ data.item.size }}</strong>
								</template>

								<template slot="quantity" slot-scope="data">
									{{data.item.count}}
								</template>

								<template slot="weight" slot-scope="data">
									<span>{{data.item.weight | |
									currency({symbol: '', fractionCount: 2,fractionSeparator: ',' ,  symbolPosition: 'back', thousandsSeparator: ''})}}</span>
								</template>
								<template slot="inWrapped" slot-scope="data">
									{{ data.item.wrapped ? getWrappedItemsAmount(data.item.wrappedItems) : '-' }}
								</template>
								<template slot="inWrappedTotal" slot-scope="data">
									{{ data.item.wrapped ? getWrappedItemsAmount(data.item.wrappedItems) * data.item.count : '-' }}
								</template>

								<template slot="priceWholesale" slot-scope="data">
									{{ data.item.priceWholesale | currency({symbol: saleCurrencyName, fractionCount: 2,
									fractionSeparator: ',',
									symbolPosition: 'back'}) }}
								</template>

								<template slot="discounts" slot-scope="data">
									<span style="color: orange; font-weight: bold;">{{ afterPromotionSum(data.item) | currency({
										symbol:
										saleCurrencyName, fractionCount: 2,
										fractionSeparator: ',', symbolPosition: 'back'
									}) }}</span>,<br>
									<span style="color: #a26000; font-weight: bold;">
										{{ afterPromotionPercentage(data.item) | currency({
											symbol:
											'%', symbolPosition: 'back'
											}) }}
									</span>
								</template>
								<!-- <template slot="percentage" slot-scope="data">
									{{ afterPromotionPercentage(data.item) | currency({
										symbol:
										'%', symbolPosition: 'back'
										}) }}
								</template> -->
								<template slot="discountPriceUzs" slot-scope="data">
									{{data.item.discountPriceUzs | currency({
										symbol: saleCurrencyName, fractionCount: 2, symbolPosition:
										'back'
										}) }}
								</template>

								<template slot="subtotal" slot-scope="data">
									{{ data.item.discountPriceUzs * data.item.count | currency({
										symbol:
										saleCurrencyName, fractionCount: 2,
										symbolPosition: 'back'
										})}}
								</template>

								<template slot="inventoryQty" slot-scope="data">
									{{ data.item.qty }} {{ data.item.unitName ? data.item.unitName : 'шт.'}}
								</template>
							</b-table>
		</b-modal>
		</b-modal>
		<!-- Suspend Modal end -->

		<!-- BOOKING DOCS MODAL BEGIN -->
		<b-modal size="xl" hide-footer ref="bookingModal">
			<div class="table-wrapper table-responsive">
				<b-table class="generalTableClass mb-2"
								:items="bookingDocsListOnlyReady"
								:fields="fieldsForBookingList"
								hover="hover" striped="striped" bordered="bordered"
								:current-page="payloadForList.page"
								:per-page="0"
								responsive show-empty
				>
					<!-- EMPTY SLOT FOR TABLE -->
					<template slot="empty" slot-scope="scope">
						<h4>{{ $t('empty') }}</h4>
					</template>
					<!-- EMPTY SLOT FOR TABLE -->

					<template slot="actions" slot-scope="data">
						<div>
							<b-link :key="data.item.id + 'convert'"
										:id="'popoverBooking'+data.item.id"
										@click="showConfirmForConvertBooking(data.item.id)"
							>
								<i class="fa fa-shopping-cart"></i>
							</b-link>
							<b-popover
								:key="data.item.id + 'popover'"
								:target="'popoverBooking'+data.item.id"
								placement="left"
								:ref="'popoverBooking'+data.item.id"
								class="refDeleteConfirm"
							>
								<template slot="title">
									<b-button @click="closeConfirmBooking(data.item.id)" class="close"
												aria-label="Close" style="margin-left: 5px">
										<span class="d-inline-block" aria-hidden="true">&times;</span>
									</b-button>
									{{ $t('booking.want_to_create_sale') }}
								</template>

								<div>
									<div class="row mt-1">
										<div class="col-6">
											<b-button variant="outline-danger" size="sm" block
														@click="closeConfirmBooking(data.item.id)"> {{ $t('actions.no') }}
											</b-button>
										</div>
										<div class="col-6">
											<b-button variant="outline-success" size="sm" block
														@click="convertBooking(data.item)">{{ $t('actions.yes') }}
											</b-button>
										</div>
									</div>
								</div>
							</b-popover>
						</div>

					</template>
				</b-table>
				<nav>
					<b-pagination :total-rows="bookingDocsTotal"
												:per-page="payloadForList.limit"
												v-model="payloadForList.page"
												:prev-text="$t('pagination.prev')"
												:next-text="$t('pagination.next')"
												hide-goto-end-buttons />
				</nav>
				<div v-if="loading" class="spinner-wrapper">
					<b-spinner variant="primary"></b-spinner>
				</div>
			</div>
		</b-modal>
		<!-- BOOKING DOCS MODAL END -->

	</b-row>

	<!-- CHECK TO PRINT BEGIN -->
	<div class="print section-to-print" v-if="!priceListStatus" id="posCheckClone">
		<div id="depNameClone" class="d-flex justify-content-center"><strong>SAMO - {{ shopName }}</strong></div>
		<div id="depAddressClone" class="d-flex justify-content-center bottom-bordered"><i>{{ shopAddress }}</i>
		</div>

		<div class="d-flex justify-content-between"><span>{{ dateTime }}</span> <span style="text-align: right;">{{$t('sidebar.pos.check')}}: {{ currentSuspendId ? currentSaleSuspendNumber : currentSaleNumber
				}}</span>
		</div>
		<div class="d-flex justify-content-between"><span>{{$t('xAtchot.cashier')}}:{{ cashierFullName }}</span> <span style="text-align: right;">POS №:{{ cashboxNumber }}</span></div>
		<div class="d-flex justify-content-between" :class="returnItemsCount == 0 ? 'bottom-bordered' : ''"><span>{{$t('pos.saller')}}:{{ currentSellerName }}</span>
			<span style="text-align: right;">{{$t('pos.items')}}:{{ totalCount }}</span></div>
		<div v-if="returnItemsCount !== 0" class="d-flex justify-content-end bottom-bordered">
			<span style="text-align: right;">Возврат кол-во:{{ returnItemsCount }}</span>
		</div>
		<div class="posCheckTable bottom-bordered">
			<table>
				<thead>
					<tr>
						<th class="alignedLeft" style="width: 50%; word-break: break-all;">{{$t('sale.products')}}</th>
						<th class="alignedCenter" style="width: 17%; word-break: break-all;">{{$t('sale.kol-vo')}}</th>
						<th class="alignedRight" style="width: 32%; word-break: break-all;">Check</th>
						<th class="alignedRight" style="width: 32%; word-break: break-all;">{{$t('incomes.create.price')}}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in getCartItems" :key="'checkItem' + index" :class="item.count < 0 ? 'returnItemBordered' : ''">
						<td class="alignedLeft" style="width: 50%; word-break: break-all;">
							<strong>{{ index + 1 }}.</strong>{{ item.name }}/<strong>{{item.artikul}}</strong>/{{item.genderName }}/{{
							item.colorName }}/<strong>{{ item.size }}</strong>
						</td>
						<td class="alignedCenter" style="width: 17%; word-break: break-all;">
							{{ item.count > 0 ? item.count : -item.count }}
						</td>

						<td class="alignedRight" style="width: 32%; word-break: break-all;">
							{{ item.discountPriceUzs * item.count | currency({
							symbol: saleCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							})}}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="posCheckTotal bottom-bordered">
			<table>
				<tbody>
					<tr>
						<td class="alignedLeft">{{$t('warehouse.table.totalIncomeUzs')}}</td>
						<td class="alignedRight">{{ finalTotalSum | currency({
							symbol: saleCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							}) }}
						</td>
					</tr>

					<tr>
						<td class="alignedLeft">{{$t('pos.ndc')}}</td>
						<td class="alignedRight">{{ finalTotalSum/6 | currency({
							symbol: saleCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							}) }}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">{{$t('xAtchot.pay')}}</td>
						<td class="alignedRight">{{ finalTotalSum | currency({
							symbol: saleCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							}) }}
						</td>
					</tr>
					<tr>
						<td class="alignedLeft">{{$t('sale.payed')}}</td>
						<td class="alignedRight">{{ totalPaid | currency({
							symbol: saleCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							}) }}
						</td>
					</tr>
					<tr v-if="returnItemsSum !== 0" class="returnItemBordered">
						<td class="alignedLeft">{{$t('pos.return')}}</td>
						<td class="alignedRight">{{ -returnItemsSum | currency({
							symbol: saleCurrencyName, fractionCount: 2,
							symbolPosition:
							'back', thousandsSeparator: ''
							}) }}
						</td>
					</tr>
					<tr v-if="parseFloat(sponsorshipAmount) > 0" class="returnItemBordered">
						<td class="alignedLeft">{{$t('sidebar.sales.sponsor')}}</td>
						<td class="alignedRight">{{ sponsorshipAmount | currency({symbol: saleCurrencyName,
							fractionCount: 2,
							symbolPosition:
							'back', thousandsSeparator: ''}) }}
						</td>
					</tr>
					<tr v-if="parseFloat(debtPayment) > 0">
						<td class="alignedLeft">{{$t('xAtchot.debt')}}</td>
						<td class="alignedRight">{{ debtPayment | currency({
							symbol: saleCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ''
							}) }}
						</td>
					</tr>
					<!--<tr>-->
					<!--<td class="alignedLeft">{{$t('promo-to-product.promo')}}</td>-->
					<!--<td class="alignedRight" v-if="customPromotion">-->
					<!--{{ customPromotion.discount }}-->
					<!--<span v-if="customPromotion.promotionType == '%'">{{ customPromotion.promotionType }}</span>-->
					<!--<span v-else>{{ userDepCurrencyName }}</span>-->
					<!--</td>-->
					<!--<td class="alignedRight" v-else>{{ 0 | currency({-->
					<!--symbol: '',-->
					<!--symbolPosition: 'back', thousandsSeparator: ''-->
					<!--}) }}-->
					<!--</td>-->
					<!--</tr>-->
				</tbody>
			</table>
		</div>
		<div class="posThanks">
			<!--<p><i>&#45;&#45; Xaridingiz uchun raxmat! &#45;&#45;      Davlat tili rus tili deb elon qilyapmizuuuuuu  ))))))))</i></p>-->
			<p><i>-- {{$t('pos.please')}}! --</i></p>
		</div>
	</div>
		<div class="print section-to-print" v-else>
			<br />
			<br />
			<div class="generalTableClass mt-5 ml-1">
				<table class="table b-table table-striped table-hover table-bordered">
					<thead>
					<tr>
						<th>ID</th>
						<th>{{ $t('goods.artikul')}}</th>
						<th>{{ $t('goods.color')}}</th>
						<th>{{ $t('goods.name')}}</th>
						<th>{{ $t('incomes.create.count')}}</th>
						<th>{{ $t('prices.item.lastPriceWholesale')}}</th>
						<th>{{ $t('prices.item.lastPriceUzs')}}</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="item,index in priceListItems.items">
						<td class="text-center">{{index + 1}}</td>
						<td class="text-center">{{item.artikul}}</td>
						<td class="text-center">{{item.color}}</td>
						<td class="text-center">{{item.name.substr(0,30)}}</td>
						<td class="text-center">{{item.count}}</td>
						<td class="text-center">{{item.priceWholesale | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}</td>
						<td class="text-center">{{item.priseUzs | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}</td>

					</tr>
					</tbody>
					<tfoot>
					<tr>
						<td class="text-right" colspan="4"><b>TOTAL: &nbsp;</b> </td>
						<th> {{ totalCountPriceList() }}</th>
						<th class="text-center">{{priceListItems.totalPriceWholeSale | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}</th>
						<th class="text-center">{{priceListItems.totalPriceUzs | currency({
							symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}</th>
					</tr>
					</tfoot>
				</table>
			</div>
		</div>
		<!-- CHECK TO PRINT END -->
	</b-container>
</template>

<script>
import {
	mapActions,
	mapGetters,
	mapState
} from 'vuex';
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import CardForPos from './components/CardForPos'
import MultiplePay from './components/MultiplePayment/MultiplePay'
import ClientForPos from './ClientForPos'
import Loading from '../../components/Loading'
import ZetReport from './components/ZetReport/ZetReport'
import XReport from './components/Xreport/Xreport'
import WithKeyboardControlForPos from "./components/WithKeyboardControlForPos";
import PosService from "../../../services/pos.service";
import {
	TokenService
} from "../../../services/storage.service";
import PosDiscount from "./components/PosDiscount";
import PosDiscountOptom from "./components/PosDiscountOptom";
import ReturnComponent from "../../return-component/ReturnComponent";

export default {
	name: "Pos",

	/** --COMPONENTS-- **/
	components: {
		CardForPos,
		ClientForPos,
		Multiselect,
		WithKeyboardControlForPos,
		MultiplePay,
		ZetReport,
		PosDiscount,
		PosDiscountOptom,
		XReport,
		Loading,
		ReturnComponent
	},
	/** --PROPS-- **/
	props: {
		mode: {
			type: String,
			default: 'create'
		}
	},
	/** --DATA-- **/
	data() {
		return {
			latestPricesModal: false,
			latestPricesButton: false,
			payloadForList: {
        page: 1,
        limit: 20,
				depIds: []
      },
			returnComponentModal:false,
			disableSuspendButton: false,
			suspendEditButtonClicked: false,
			saleCurrencyOld: null,
			converButtonClicked: false,
			suspendClicked: false,
			transactionCollapsed: true,
			saleCurrency: null,
			currencyCheckbox: false,
			depCurrencyRate: null,
			saleCurrencyRate: null,
			toggleCurrencyInputs: false,
			sampleForAttrId: {
				"field": "category.id",
				"value": "",
				"type": "long",
				"option": "EQUALS",
				"orderBy": "desc"
			},
			contragentsLoading: false,
			categoryOptions: {
				items: [],
				value: null
			},
			groupOptions: {
				items: [],
				value: null
			},
			selectContrAgent: false,
			publicPath: process.env.BASE_URL,
			currentItemIndex: null,
			barcodeScanned: false,
			isCountBtnsDisabled: false,
			returnMoney: 0,
			returnItemsCount: 0,
			returnItemsSum: 0,
			debtPayment: 0,
			sponsorshipAmount: 0,
			totalPaid: 0,
			cashboxNumber: localStorage.getItem('cash_number'),
			posSearchValue: '',
			dateTime: '',
			discountOpenModal: false,
			discountOptomOpenModal: false,
			openClicked: false,
			checkedClient: {},
			currentClient: null,
			currentIndex: 0,
			objectForCountIncrement: {},
			tempForSale: {
				'action': 'OPTOM_SAVDO',
			},
			localComment: '',
			multiPays: [],
			zreport: false,
			xreport: false,
			timeout: null,
			suspendActive: false,
			message: '',
			discountTForTitle: false,
			totalPayable: 0,
			confirmEndSession: false,
			savdoType: 'isOptom',
			contrAgent: null,
			discountOptom: null,
			sessionStart: {
				started: false,
				code: null,
				codeState: null,
				message: 'Ошибка на сервере, пожалуйста, попробуйте чуть позже...',
				isFail: false,
			},
			localFieldsForBooking: [],
			fields: [
				{
					key: 'number',
					label: '№'
				},
				{
					key: 'artikul',
					label: this.$t('pos.product'),
					'class': 'noDefaultButton width15_wordBreak'
				},
				{
					key: 'quantity',
					label: this.$t('goods.amount'),
					'class': 'noDefaultButton, width15_wordBreak',
				},
				{
					key: 'priceWholesale',
					label: this.$t('incomes.create.price')
				},
				{
					key: 'pul',
					label: this.$t('promo-to-product.promo')
				},
				{
					key: 'percentage',
					label: this.$t('promo-to-product.promo') + ' %'
				},
				{
					key: 'discountPriceUzs',
					label: this.$t('pos.promo')
				},

				{
					key: 'subtotal',
					label: this.$t('pos.sum')
				},

				{
					key: 'inventoryQty',
					label: this.$t('pos.inventoryQty'),
					'class': 'textAlignCenter'
				},
				// {
				// 	key: 'delete',
				// 	label: this.$t('goods.actions'),
				// 	'class': 'table_actions'
				// },
				// {
				// 	key: 'update',
				// 	label: this.$t('goods.actions'),
				// 	'class': 'table_actions'
				// },
				{
					key: 'actions',
					label: 'Действие',
					'class': 'width7_wordBreak table_actions'
				}
			]
		}
	},

	/** --COMPUTED-- **/
	computed: {
		...mapState('booking', [
			'bookingDocsList', 'bookingDocsTotal', 'loading',
			'fieldsForBookingList', 'currentDoc', 'currentBookingItems',
			'bookingError', 'convertResponse'
		]),
		...mapGetters('references', [
			'getCategoryChildren'
		]),
		...mapGetters('contragents', [
			'getContragentsForPos'
		]),
		...mapGetters('wholesalePos', [ 'getSaleItemsForExcel',
			'getItems', 'getCartItems', 'getDiscountItemForModal', 'getTotalWeight'
		]),
		...mapState(['isCashier', 'userDepCurrencyName', 'userDepCurrencyId', 'userDepId']),
		...mapState('contragents', [
			'contragentSaldo', 'contragentSaldoError'
		]),
		...mapState('wholesalePos', [
			'totalCount', 'totalSum','checkPage', 'finalTotalSum', 'realTotalSum', 'comment',
			'shopName', 'currentSaleNumber',
			'currentSaleId', 'latestSuspends',
			'shopAddress', 'cashierFullName', 'currentSellerName', 'sellerId',
			'currentSuspendId', 'currentSaleSuspendNumber', 'lastSuspendedSaleNumber', 'saleItemForDiscountModal', 'discount', 'customPromotion', 'errorOccur',
			'searchLoading', 'saleFinishError', 'saleFinishLoading',
			'isReturn', 'convertError', 'withDocumentStore', 'priceListStatus', 'priceListItems',
			'priceChangedResponse', 'loadingForPosTable', 'wholesalePosError', 'fetchLoading',
			'currentSuspendSale'
		]),
		...mapGetters('clients', [
			'getFromModalMemberCard', 'getCurrentClient', 'getCurrentClientFromModal'
		]),
		...mapGetters('zetReport', [
			'getCurrentSession', 'getZetReport', 'getReportX'
		]),
		getPriceChanged() {
			let payload = {
				boolean: false,
				indexes: []
			}
			for(let i = 0; i < this.getCartItems.length; i++){
				if (this.getCartItems[i].priceChanged) {
					Vue.set(this.getCartItems[i], '_cellVariants', {priceWholesale: 'warning'})
					payload.boolean = true;
					payload.indexes.push(i+1);
				}
			}
			return payload;
		},
		bookingDocsListOnlyReady() {
			return this.bookingDocsList.filter(el => el.status == 'READY');
		},
		totalCountItems() {
			let total = 0;
			this.getCartItems.forEach(el => {
				if(el.wrapped && el.wrappedItems) {
					el.wrappedItems.forEach(item => {
						total += el.count * item.amount
					})
				} else if (!el.wrapped) {
					total += el.count;
				}
			})
			return total
		},
		itemsForExcel() {
				if(this.getSaleItemsForExcel) {
					let array = []
					let temp;
					this.getSaleItemsForExcel.forEach((el, index) => {
						temp = Object.assign({},
							{
								"#": index+1,
								"Продукты": el.name + '/' + el.artikul + '/' + el.colorName  + el.size,
								"Количество": el.count,
								"Вес (кг)": this.$options.filters.currency(el.weight,{symbol: '', fractionCount: 2,fractionSeparator: ',', symbolPosition: 'back', thousandsSeparator: ''} ),
								"В мешке" : el.wrapped ? this.getWrappedItemsAmount(el.wrappedItems) : '-' ,
								"Кол-во изд": el.wrapped ? this.getWrappedItemsAmount(el.wrappedItems)* el.count : '-' ,
								"Цена": el.priceWholesale,
								"Скидки":  this.afterPromotionPercentage(el) ,
								"Цена со скидкой": this.$options.filters.currency(el.discountPriceUzs,{symbol: '', fractionCount: 2,fractionSeparator: ',', symbolPosition: 'back', thousandsSeparator: ''} ) ,
								"Сумма":  this.$options.filters.currency((el.discountPriceUzs * el.count ),{symbol: '', fractionCount: 2,fractionSeparator: ',', symbolPosition: 'back', thousandsSeparator: ''} ),
								"Остатка": this.getData(el)
							}
						);
						array.push(temp)
					})
						return array
				}
			},
		computedFieldsModal() {
			return [
				{
					key: 'id',
					label: '№',
					sortable: true,
					'class': ['text-center',  'align-middle'],
				},
				{
					key: 'saleNumber',
					label: this.$t('sidebar.pos.check'),
					'class': ['text-center',  'align-middle'],
				},
				{
					key: 'saleDate',
					label: this.$t('pos.date'),
					'class': ['text-center', 'align-middle'],
				},
				{
					key: 'comment',
					label: this.$t('comment'),
					'class': ['text-center',  'align-middle'],
				},
				{
					key: 'cashierFullName',
					label: this.$t('xAtchot.cashier'),
					'class':['text-center',  'align-middle'],
				},
				{
					key: 'contragentName',
					label: this.$t('sidebar.sales.contragent'),
					'class': ['text-center', 'align-middle'],
				},
				{
					key: 'excel',
					label: this.$t('excel-export.title'),
					'class': ['text-center', 'align-middle', 'table_actions'],
				},
			]
		},
		computedFields() {
			return [{
					key: 'id',
					label: '№',
					'class': 'min-30',
					sortable: true
				},
				{
					key: 'saleNumber',
					label: this.$t('sidebar.pos.check'),
					'class': 'min-100',
				},
				{
					key: 'saleDate',
					label: this.$t('pos.date'),
					'class': 'min-130 fixed',
				},
				// {
				// 	key: 'middleName',
				// 	label: this.$t('client.create.middle-name')
				// },
				// {
				// 	key: 'memberCard',
				// 	label: "Member card"
				// },

				{
					key: 'actions',
					label: this.$t('actions.title'),
					'class': 'table_actions min-60',

				},

			]
		},
		saleCurrencyName() {
			if (this.refCurrencies.length >= 0 && this.saleCurrency && this.isCurrenciesDifferent) {
				if(this.converButtonClicked) {
					let temp = this.refCurrencies.find(el => el.id == this.saleCurrency);
					return temp ? temp.name : '';
				}else {
						if(this.saleCurrencyOld){
							let temp = this.refCurrencies.find(el => el.id == this.saleCurrencyOld);
							return temp ? temp.name : '';
						}else{
							return this.userDepCurrencyName;
						}
				}
			} else {
				if(!this.isCurrenciesDifferent) {
					if(this.currencyCheckbox && this.saleCurrency ){
						this.saleCurrencyOld = null;
						this.converButtonClicked = false;
						this.saleCurrencyOld = null;
						this.converButtonClicked = false
						this.saleCurrency = null;
						this.depCurrencyRate = null;
						this.saleCurrencyRate = null;
						if (!this.suspendClicked) {
							this.savePos('forConvert');
						} else {
							this.suspendClicked = false;
						}
					}
					return this.userDepCurrencyName;
				}else{
					return this.userDepCurrencyName;
				}
			}
		},
		...mapState('references', [
			'refCurrencies'
		]),
		isCurrenciesDifferent() {
			if (this.userDepCurrencyId && this.saleCurrency) {
				if (parseFloat(this.userDepCurrencyId) !== this.saleCurrency) {
					if (!this.toggleCurrencyInputs) {
						this.saleCurrencyRate = 1;
						// this.depCurrencyRate = null;
					} else {
						this.saleCurrencyRate = null;
						this.depCurrencyRate = 1;
					}
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
		imageUrl() {
			return process.env.VUE_APP_ROOT_API + '/item/photo/'
		},
		setTotalSum() {
			let resultSum = 0;
			for (let i = 0; i < this.getCartItems.length; i++) {
				resultSum += (this.getCartItems[i].discountPriceUzs ? this.getCartItems[i].discountPriceUzs : this.getCartItems[i].priceWholesale)  * this.getCartItems[i].count;
			}
			return resultSum;
		},
		setBezSkidkaSum() {
			let resultSum1 = 0;
			for (let i = 0; i < this.getCartItems.length; i++) {
				resultSum1 += this.getCartItems[i].priceWholesale * this.getCartItems[i].count;
			}
			return resultSum1;
		},
		computedCurrentIndex() {
			return this.currentIndex;
		},
	},

	/** --WATCHERS-- **/
	watch: {
		'payloadForList.page': {
			async handler() {
				await this.fetchBookingDocs(this.payloadForList)
			}
		},
		saleCurrency: {
			async handler(newVal, oldValue) {
				if(oldValue && this.converButtonClicked) {
					this.converButtonClicked = false
					this.saleCurrencyOld = oldValue
				}
					if(this.suspendEditButtonClicked) {
						this.converButtonClicked = true;
						this.suspendEditButtonClicked = false;
					}else {
						this.converButtonClicked = false;
					}
			}
		},
		currencyCheckbox: {
			async handler(newVal) {
				if (newVal) {
					await this.getReferenceChildren('CURRENCY');
				} else {
					this.saleCurrencyOld = null;
					this.converButtonClicked = false
					this.saleCurrency = null;
					this.depCurrencyRate = null;
					this.saleCurrencyRate = null;
					if (!this.suspendClicked) {
						this.savePos('forConvert');
					} else {
						this.suspendClicked = false;
					}
				}
			}
		},
		toggleCurrencyInputs: {
			handler(newVal) {
				if (newVal) {
					this.saleCurrencyRate = 1;
					this.depCurrencyRate = null;
				} else {
					this.saleCurrencyRate = null;
					this.depCurrencyRate = 1;
				}
			}
		},
		contrAgent: {
			async handler(newVal) {
				if (newVal) {
					await this.getConragentSaldo(newVal.id)
					this.tempForSale.contragentId = newVal.id;
				} else {
					this.tempForSale.contragentId = null;
				}
			}
		},
		'categoryOptions.value': {
			handler(newVal) {
				if (newVal) {
					this.tempForSale.categoryId = newVal
				} else {
					this.tempForSale.categoryId = null
				}
			}
		},

		'sessionStart.code': {
			handler(newValue) {
				if (newValue !== '12345') {
					this.sessionStart.codeState = 'invalid'
				} else {
					this.sessionStartOk()
				}
			}
		}
	},

	/** --METHODS-- **/
	methods: {
		async removePageSizeStyle() {
			var el = document.getElementById('stylePrintSizeId');
			if (el) {
				el.remove(); // Removes the div with the 'stylePrintSizeId' id
			}
		},
		async setPageSizeStyle(sizeValue) {
			var css = `@page { size: ${sizeValue}; }`,
			head = document.head || document.getElementsByTagName('head')[0],
			style = document.createElement('style');

			style.type = 'text/css';
			style.media = 'print';
			style.id = 'stylePrintSizeId';

			if (style.styleSheet){
				style.styleSheet.cssText = css;
			} else {
				style.appendChild(document.createTextNode(css));
			}

			head.appendChild(style);
		},
		...mapActions('booking', [
      'fetchBookingDocs', 'getBookingDocById', 'getBookingItemsByDocId', 'convertBookingToSale'
	]),
	makeTooltipForPrice(incomeDates) {
				let str = '';
				incomeDates.forEach((date, index) => {
					str = str + date + (incomeDates.length - 1 == index ? ' ' : ', ');
				})
				return str;
			},
		async setLatestPricesForSale() {
			let priceChangedItems = this.getCartItems.filter(el => {
				return el.priceChanged == true;
			})
			let payload = {
				saleId: this.currentSuspendId ? this.currentSuspendId : this.currentSaleId,
				priceChangedItems: priceChangedItems
			}
			if (payload.priceChangedItems.length > 0) {
				await this.setLatestPrices(payload);
				if (this.wholesalePosError.boolean) {
					this.$vs.notify({
	          title: this.$t('words.error'),
	          text: this.wholesalePosError.message,
	          color: 'danger',
	          icon: 'close',
	          position: 'top-right'
	        })
					return;
				} else {
					let foundSaleIndex = this.latestSuspends.findIndex(el => el.id == this.currentSuspendId);
					this.updateDraft(this.latestSuspends[foundSaleIndex]);
				}
			}
		},
		showLatestPricesModal() {
			this.latestPricesModal = true;
		},
		async openBookingDocsModal(){
			this.$refs.bookingModal.show()
			await this.fetchBookingDocs(this.payloadForList);
		},
		closeBookingDocsModal() {
			this.$refs.bookingModal.hide();
		},
		setColumns() {
			this.localFieldsForBooking = this.filterColumns(this.fieldsForBookingList);
		},
    filterColumns(columns = []) {
			return columns.filter(column => {
				if (column.visible) {
					column.label = this.$t(column.label);
					return column
				}
			})
		},
		showConfirmForConvertBooking(id) {
      let refName = 'popoverBooking' + id;
      this.$refs[refName].$emit('open');
    },
    closeConfirmBooking(id) {
      let refName = 'popoverBooking' + id;
      this.$refs[refName].$emit('close');
    },
		async convertBooking(bookingDoc) {
			this.$store.commit('booking/setListLoading', true);
			await this.convertBookingToSale(bookingDoc);
			if (this.bookingError.boolean) {
				this.$store.commit('booking/setListLoading', false);
        this.$vs.notify({
          title: this.$t('words.error'),
          text: this.bookingError.message,
          color: 'danger',
          icon: 'close',
          position: 'top-right'
        })
      } else {
				await this.$store.commit('wholesalePos/setDraft', this.convertResponse);
				await this.editBookingResponse(this.convertResponse);
				this.$store.commit('booking/setListLoading', false);
				this.$vs.notify({
          text: this.$t('booking.saleCreated') + ' ' + this.convertResponse.saleNumber,
          color: 'success',
          icon: 'close',
          position: 'top-right'
        })
				if (this.convertResponse.categoryId) {
					this.categoryOptions.value = this.convertResponse.categoryId
					await this.categoryFilterChanged(this.convertResponse.categoryId)
				}else {
					this.categoryOptions.value = null
					await this.categoryFilterChanged(null)
				}
				if (this.convertResponse.contragentId) {
					this.contrAgent = this.getContragentsForPos.find(el => this.convertResponse.contragentId == el.id)
				}else {
					this.contrAgent = null
				}
				this.closeBookingDocsModal();
      }
			this.closeConfirmBooking(bookingDoc.id);
		},
		tableToExcel(tableID) {
        			var tab_text = "<table border='2px'><tr bgcolor='#87AFC6'>";
        			var textRange = "<p text-align=''";
        			var j = 0;
        			let tab = document.getElementById(tableID); // id of table

        			for (j = 0; j < tab.rows.length; j++) {
        				tab_text = tab_text + tab.rows[j].innerHTML + "</tr>";
        				//tab_text=tab_text+"</tr>";
        			}

        			tab_text = tab_text + "</table>";
        			tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");//remove if u want links in your table
        			tab_text = tab_text.replace(/<img[^>]*>/gi, ""); // remove if u want images in your table
        			// tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, ""); // reomves input params

        			var ua = window.navigator.userAgent;
        			var msie = ua.indexOf("MSIE ");

        			if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer
        			{
        				txtArea1.document.open("txt/html", "replace");
        				txtArea1.document.write(tab_text);
        				txtArea1.document.close();
        				txtArea1.focus();
        				var sa = txtArea1.document.execCommand("SaveAs", true, "Say Thanks to Sumit.xls");
        			} else                 //other browser not tested on IE 11
        				sa = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(tab_text));

        			return (sa);
        		},
		getData(el) {
			if(el.unitName) {
				return el.qty + ' ' + el.unitName
			}else {
				el.qty + ' ' + 'шт.'
			}
		},
		async fetchData(data) {
			await this.$refs.suspendModalItems.show()
			await this.editForExcelSuspend(data)
		},
		suspendModal() {
			this.$refs.suspendModal.show()
		},
		getWrappedItemsAmount(wrappedItems) {
			let inWrappedAmount = 0;
			if (wrappedItems) {
				wrappedItems.forEach(item => inWrappedAmount += item.amount)
			}
			return inWrappedAmount;
		},
		closeModalWindow(name) {
			this[name] = false;
		},
		openReturnComponentModal(){
			this.returnComponentModal = true;
		},
		totalCountPriceList(){
			let count = 0;
			if(this.priceListItems.items){
				this.priceListItems.items.forEach(item => {
					count += parseInt(item.count)
				});
			}
			return count;
		},
		onClose(itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('close')
		},
		onOpen(itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('open')
		},
		async onOk(itemId) {
			this.onClose(itemId);
			this.suspendClicked = true;
			await this.deleteSuspendStore(itemId);
			await this.getLatestSuspends();
			if (this.currentSuspendId == itemId) {
				await this.changeSuspendActive(false);
				await this.focusSearchBar();
				this.$store.commit('wholesalePos/resetState');
				this.$store.commit('wholesalePos/resetSuspendId');
			}

		},
		async updateDraft(data, fromCancelButton = false) {
			this.disableSuspendButton = true;
			await this.editForPosDraft(data);
			this.disableSuspendButton = false;
			await this.changeSuspendActive(true, fromCancelButton);
			await this.focusSearchBar();
			this.suspendClicked = false;
			if (data.currencyId && data.depCurrencyRate) {
				this.converButtonClicked = true;
				this.currencyCheckbox = true;
				this.saleCurrency = data.currencyId;
				this.saleCurrencyRate = data.saleCurrencyRate;
				this.depCurrencyRate = data.depCurrencyRate;
				this.saleCurrencyOld = null;
				this.suspendEditButtonClicked = true;
			}else {
				this.saleCurrencyOld = null
				this.converButtonClicked = false;
				this.saleCurrencyOld = null
				this.currencyCheckbox = false;
				this.saleCurrency = null;
				this.saleCurrencyRate = null;
				this.depCurrencyRate = null;
			}
			if (data.categoryId) {
				this.categoryOptions.value = data.categoryId
				await this.categoryFilterChanged(data.categoryId)
			}else {
				this.categoryOptions.value = null
				await this.categoryFilterChanged(null)
			}
			if (data.contragentId) {
				this.contrAgent = this.getContragentsForPos.find(el => data.contragentId == el.id)
			}else {
				this.contrAgent = null
			}
			this.discountOptom = null;
		},
		toggleIsReturn(boolean) {
			this.$store.commit('wholesalePos/setIsReturn', boolean);
			this.$emit('searchBarFocus');
		},
		makeSaleCurrencyName(currencyId) {
			if (this.refCurrencies.length > 0 && currencyId) {
				let temp = this.refCurrencies.find(el => el.id == currencyId);
				return temp ? temp.name : '';
			} else {
				return '';
			}
		},
		async cancelAndClearInventory() {
			this.$emit('close', true);
		},
		...mapActions('contragents', [
			'fetchContragents',
			'setCurrentPage', // receives currentPage
			'setParamForFilter', // receives fieldObj
			'deleteParamFromFilter', // receives fieldName
			'resetParamForFilter', // receives nothing; just call and it resets the filter
			'deleteContragentStore',
			'createContragentStore',
			'changeFieldsForTable',
			'getConragentSaldo'
		]),
		...mapActions('references', [
			'getReferenceChildren',
		]),
		async getContragentsForWholesale() {
			await this.getReferenceChildren('CONTRAGENT_CATEGORY');
			this.categoryOptions = Object.assign({}, this.getCategoryChildren);
		},
		/* CATEGORY FILTER FUNC */
		async categoryFilterChanged(categoryId) {
			let fieldName = 'category.id';
			this.contrAgent = null;
			if (categoryId) {
				this.sampleForAttrId.field = fieldName;
				this.sampleForAttrId.value = categoryId;

				this.deleteParamFromFilter(fieldName);
				let fieldObj = Object.assign({}, this.sampleForAttrId);
				this.setParamForFilter(fieldObj);
			} else {
				if (!this.groupOptions.value) {
					this.resetParamForFilter();
				} else {
					this.deleteParamFromFilter(fieldName);
				}
			}
			// GET FILTERED DATA
			this.contragentsLoading = true;
			await this.fetchContragents('pos');
			this.contragentsLoading = false;
		},
		/* CLEARING FILTER */
		clearCategoryFilter() {
			this.categoryOptions.value = null;
			this.contrAgent = null;
		},
		focusMyDiscount() {
			this.$refs.posDiscount.$refs.fixedRef.focus();
			this.$refs.posDiscount.$refs.percentageRef.focus();
		},
		focusMyOptomDiscount() {
			this.$refs.posOptomDiscount.$refs.fixedOptomRef.focus();
			this.$refs.posOptomDiscount.$refs.percentageOptomRef.focus();
		},

		commentForSuspend(value) {
			this.localComment = value;
		},
		changeSuspendActive(booleanValue, fromCancelButton = false) {
			this.suspendActive = booleanValue
			this.localComment = this.comment;
			if (booleanValue && !fromCancelButton) {
				this.$vs.notify({
					title: 'Продажа №: ' + this.currentSaleSuspendNumber + ' выбрана',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				});
			} else {
				this.discountOptom = null;
				this.currencyCheckbox = false;
				this.saleCurrency = null;
				this.saleCurrencyRate = null;
				this.depCurrencyRate = null;
				this.contrAgent = null;
				this.categoryOptions.value = null
			}
		},
		afterPromotionSum(item) {
			if (item.customPromotion) {
				if (item.customPromotion.promotionType == 'PUL') {
					return item.customPromotion.discount;
				}
			}
		},

		afterPromotionPercentage(item) {
			if (item.customPromotion) {
				if (item.customPromotion.promotionType == '%') {
					return item.customPromotion.discount;
				}
			}
		},
		...mapActions('wholesalePos', [
			'fetchWholesaleSearchItems', 'getItemsForPos', 'increaseCount', 'addToCartAction', 'setIncrementValue',
			'decreaseCount', 'deleteFromCartAction', 'saleFinish', 'createPosDraft',
			'editDraft', 'getLatestSuspends', 'suspendSale', 'setSaleItemForDiscountModal',
			'setSusPendClient', 'setErrorOccurNotHappen', 'editDraftOptom',
			'editWholesale', 'convertCurrency', 'editForPosDraft', 'editForExcelSuspend', 'deleteSuspendStore',
			'setItemWeightAction', 'editBookingResponse', 'setLatestPrices'
		]),
		...mapActions('references', [
			'loadPaymentMethods'
		]),
		...mapActions('clients', [
			'emptyObjectStore'
		]),
		...mapActions('zetReport', [
			'startSessionToDep', 'getZReport', 'getXReport'
		]),
		getOutOfStockError() {
			let error = false;
			for (let item of this.getCartItems) {
				if (item.count > item.qty && !item._rowVariant) {
					error = true;
					break;
				}
			}
			return error;
		},
		multiplePayment() {
			if (this.getCartItems.length > 0) {
				if (this.tempForSale.action == 'OPTOM_SAVDO') {
					if (!this.tempForSale.contragentId) {
						this.$vs.notify({
							title: 'Пожалуйста выберите контрагента',
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
						return 0;
					}
				}
				let hasOutOfStockItem = this.getOutOfStockError();
				let booleanAndIndexes = this.getPriceChanged;
				this.latestPricesButton = false;
				if (hasOutOfStockItem) {
					this.$vs.notify({
						title: 'Пожалуйста, проверьте количество продуктов',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
					this.focusSearchBar();
				} else if (booleanAndIndexes.boolean) {
					this.latestPricesButton = true;
					let stringIndexes = booleanAndIndexes.indexes.join(', ');
					this.$vs.notify({
						title: `Проверьте эти товары №: "${stringIndexes}"`,
						text: 'если цена была изменена, то удалите и добавьте снова',
						time: 6500,
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				} else {
					this.latestPricesButton = false;
					this.openClicked = true;
					this.$refs.multiPayModal.show()
				}
			} else {
				this.openClicked = false;
				this.$vs.notify({
					title: 'Пожалуйста, добавьте продукт',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
				this.focusSearchBar();
			}
		},
		closeXreport() {
			this.xreport = false
			this.$refs.xreport.hide()

		},

		showConfirmEndSession() {
			this.confirmEndSession = true
		},
		openItemForDiscount(data, index) {
			if (data.item.customPromotion.discount) {
				if (data.item.customPromotion.promotionType == '%') {

					this.$refs.posDiscount.itemLocal.percentage = data.item.customPromotion.discount;
					this.$refs.posDiscount.itemLocal.fixed = '';
				} else {

					this.$refs.posDiscount.itemLocal.fixed = data.item.customPromotion.discount;
					this.$refs.posDiscount.itemLocal.percentage = '';
				}
			} else {
				this.$refs.posDiscount.itemLocal.fixed = '';
				this.$refs.posDiscount.itemLocal.percentage = '';
			}
			this.currentItemIndex = index;
			this.setSaleItemForDiscountModal(data);
			this.discountTForTitle = true;
			this.discountOpenModal = true;
		},
		openItemForDiscountGeneral() {
			if (this.customPromotion) {
				if (this.customPromotion.promotionType == '%') {
					this.$refs.posDiscount.itemLocal.percentage = this.customPromotion.discount;
					this.$refs.posDiscount.itemLocal.fixed = '';
				} else {
					this.$refs.posDiscount.itemLocal.fixed = this.customPromotion.discount;
					this.$refs.posDiscount.itemLocal.percentage = '';
				}
			} else if (this.getFromModalMemberCard.memberCardDiscount) {
				this.$refs.posDiscount.itemLocal.percentage = this.getFromModalMemberCard.memberCardDiscount;
				this.$refs.posDiscount.itemLocal.fixed = '';
			} else {
				this.$refs.posDiscount.itemLocal.fixed = '';
				this.$refs.posDiscount.itemLocal.percentage = '';
			}
			this.discountTForTitle = false
			this.discountOpenModal = true;
			this.setSaleItemForDiscountModal(this.discountTForTitle);

		},

		closeEmit(event) {
			this.discountOpenModal = event;
		},
		async saveOptomDiscount(event) {
			if (event.promotionType === "%") {
				this.discountOptom = event.discount + ' ' + "%"
			} else {
				this.discountOptom = event.discount + ' ' + this.saleCurrencyName;
			}

			if (this.getCartItems.length !== 0) {
				this.getCartItems.forEach((item, index) => {
					let obj = {}

					if (event.promotionType === "%") {
						obj.promotionType = "%";
						obj.discount = event.discount;
						if (this.currentSuspendId) {
							obj.saleId = this.currentSuspendId;
						} else {
							obj.saleId = this.currentSaleId;
						}
					} else {
						obj.promotionType = 'PUL';
						obj.discount = event.discount;
						if (this.currentSuspendId) {
							obj.saleId = this.currentSuspendId;
						} else {
							obj.saleId = this.currentSaleId;
						}
					}

					let payload = {
						index: index,
						obj: obj
					}
					this.setOptomPromotion(payload)
				})
				this.savePos('draft')
			} else {
				this.discountOptom = null
			}

			if (event.setToNull) {
				this.discountOptom = null
			}
			this.discountOptomOpenModal = false

		},
		async setOptomPromotion(payload) {
			await this.$store.commit('wholesalePos/setCustomPromotionForItem', payload);
		},

		closeOptomDiscount(event) {
			this.discountOptomOpenModal = event;
		},
		openModalForOptomDiscount() {
			this.discountOptomOpenModal = true
		},

		showZReport() {
			this.confirmEndSession = false
			this.zreport = true
			this.$refs.zreport.show()
		},
		showXReport() {
			this.xreport = true
			this.$refs.xreport.show()
		},
		closeZreport() {
			this.zreport = false
			this.$refs.zreport.hide()
			this.cancelAndClearInventory();
			// this.$router.go()
			// if (this.isCashier) {
			// 	this.$store.dispatch('logout')
			// }
		},
		closePayment() {
			this.openClicked = false;
			this.$refs.multiPayModal.hide()
		},
		minimizePayment() {
			this.openClicked = false;
			this.$refs.multiPayModal.hide()
		},
		savdoTypeChanged($event) {
			this.changeDefaultValueToOptomAndDona();
			if ($event.type === 'isOptom') {
				this.tempForSale.action = 'OPTOM_SAVDO';
				this.tempForSale.contragentId = $event.cont ? $event.cont.id : null;
			} else {
				this.tempForSale.action = 'SOTISH';
				delete this.tempForSale.contragentId
			}
			this.focusSearchBar();
			this.clearSearchBar();
			this.tempForSale.customPromotion = this.customPromotion;
			this.tempForSale.saleItems = this.getCartItems;
			this.editDraftOptom(this.tempForSale);
			this.savdoType = $event.type
		},
		changeDefaultValueToOptomAndDona() {
			this.discountOptom = null
		},

		async successMultiPay(isCheck, paymentMethods, totalPaid, debtPaymentAmount, returnItemsCount, returnItemsSum, sponsorshipAmount) {
			this.returnMoney = 0;
			this.returnItemsCount = returnItemsCount;
			this.returnItemsSum = returnItemsSum;
			this.sponsorshipAmount = sponsorshipAmount;
			this.totalPaid = totalPaid;
			let forCheckWholeSale = {}
			forCheckWholeSale.returnMoney = this.returnMoney;
			forCheckWholeSale.returnItemsCount = this.returnItemsCount;
			forCheckWholeSale.returnItemsSum = this.returnItemsSum;
			forCheckWholeSale.sponsorshipAmount = this.sponsorshipAmount;
			forCheckWholeSale.totalPaid = this.totalPaid;
			forCheckWholeSale.debtPayment = this.debtPayment;
			this.$store.commit('wholesalePos/setTotalPaid', forCheckWholeSale);
			this.multiPays = paymentMethods;
			this.debtPayment = debtPaymentAmount;
			await this.savePos('ready');
			if (this.saleFinishError) {
				this.$store.commit('wholesalePos/setPosDisabled', false);
				return 0;
			} else {
				await this.makeCurrentDateTime();
				this.$refs.multiPayModal.hide()
				this.openClicked = false;
				if (isCheck) {
					let vm = this;
					vm.$emit('close', true);

					setTimeout( async function() {
							await vm.removePageSizeStyle();
							await vm.setPageSizeStyle('portrait');
							window.print();
							/** RESET STATE **/
							vm.$store.commit('wholesalePos/resetState');
							vm.$store.commit('wholesalePos/resetSuspendId');
							vm.$store.commit('wholesalePos/setSellerName', '');
							vm.$store.commit('wholesalePos/setSellerName', '');
							vm.$store.commit('wholesalePos/setSellerId', null);
							vm.$store.commit('certificates/setCertificateForPos', null);
							// vm.$store.dispatch('wholesalePos/createPosDraft', {
							// 	'action': 'OPTOM_SAVDO',
							// });
							vm.$store.commit('wholesalePos/resetSuspendId');
							vm.suspendActive = false;
						}, 1000);
				} else {
					this.$emit('close', true);
					/** RESET STATE **/
					this.$store.commit('wholesalePos/resetState');
					this.$store.commit('wholesalePos/resetSuspendId');
					this.$store.commit('wholesalePos/setSellerName', '');
					this.$store.commit('certificates/setCertificateForPos', null);
					this.$store.commit('wholesalePos/setSellerId', null);
					// this.$store.dispatch('wholesalePos/createPosDraft', {
					// 	'action': 'OPTOM_SAVDO',
					// });
					this.$store.commit('wholesalePos/resetSuspendId');
					this.suspendActive = false;
				}

				this.$store.commit('wholesalePos/setPosDisabled', false);
				await this.focusSearchBar();
			}
		},
		async saveSuspend() {
			if (this.getCartItems.length > 0) {
				this.suspendClicked = true;
				await this.savePos('suspended');
				await this.$store.commit('wholesalePos/resetState');
				//this.$emit('close', true);
				if (this.getCurrentClientFromModal) {
					this.setSusPendClient(this.getCurrentClientFromModal);
				}
				if (this.getFromModalMemberCard) {
					this.setSusPendClient(this.getFromModalMemberCard);
				}
				await this.$store.commit('clients/resetCurrentClient');
				await this.getLatestSuspends();
				if (this.currentSuspendId == null) {
					await this.createPosDraft({
						action: "OPTOM_SAVDO"
					});
					this.$store.commit('wholesalePos/resetSuspendId');
				}
				this.$store.commit('wholesalePos/resetSuspendId');
				this.localComment = '';

				await this.$vs.notify({
					title: 'Продажа №: ' + this.lastSuspendedSaleNumber + ' успешно сохранена',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				});
				this.suspendActive = false;
				this.focusSearchBar();
				this.clearSearchBar();
				this.currencyCheckbox = false;
				this.saleCurrency = null;
				this.saleCurrencyRate = null;
				this.depCurrencyRate = null;
				this.discountOptom = null;
				this.contrAgent = null;
				this.categoryOptions.value = null
			} else {
				this.$vs.notify({
					title: 'Пожалуйста, добавьте продукт',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
				this.focusSearchBar()
			}

		},
		getCountOfItem(index) {
			return this.getCartItems[index].count > 0 ? this.getCartItems[index].count : -this.getCartItems[index].count;
		},
		async savePos(status) {
			this.discountOpenModal = false;
			if (this.getFromModalMemberCard) {
				this.tempForSale.customerId = this.getFromModalMemberCard.id;
			} else if (this.getCurrentClient) {
				this.tempForSale.customerId = this.getCurrentClient.id;
			} else if (this.getCurrentClientFromModal) {
				this.tempForSale.customerId = this.getCurrentClientFromModal.id;
			} else {
				this.tempForSale.customerId = null;
			}
			this.tempForSale.comment = this.localComment;
			this.tempForSale.saleDate = this.makeCurrentDateTime('savePos')
			this.tempForSale.depCurrencyRate = this.depCurrencyRate;
			this.tempForSale.saleCurrencyRate = this.saleCurrencyRate;
			this.tempForSale.currencyId = this.saleCurrency;
			this.tempForSale.cashboxNumber = localStorage.getItem('cash_number');
			this.tempForSale.amountOfPaymentUzs = this.realTotalSum;
			this.tempForSale.amountOfAfterPromoUzs = this.finalTotalSum;
			this.tempForSale.customPromotion = this.customPromotion;
			this.tempForSale.cashierFullName = this.cashierFullName;
			this.tempForSale.sellerId = this.sellerId;
			this.tempForSale.saleItems = this.getCartItems;
			// ADDED ON 12.05.2020 FOR LOCAL CALCULATIONS BEGIN
			this.tempForSale.saleItems.forEach(el => {
				el.isOptom = true;
				if (el.customPromotion) {
					if(Object.keys(el.customPromotion).length > 0) {
						if(el.customPromotion.promotionType == '%') {
							let discountPercentage = 1 - parseFloat(el.customPromotion.discount)/100;
							el.discountPriceUzs = discountPercentage * el.priceWholesale;
						} else if (el.customPromotion.promotionType == 'PUL') {
							el.discountPriceUzs = el.priceWholesale - parseFloat(el.customPromotion.discount);
						}
					}
				}
			})
			this.tempForSale.finalTotalSum = this.setTotalSum;
			this.tempForSale.realTotalSum = this.setBezSkidkaSum;
			// ADDED ON 12.05.2020 FOR LOCAL CALCULATIONS END
			if (this.multiPays) {
				this.tempForSale.payments = this.multiPays
			}
			if (status == 'ready') {
				if (this.getCartItems.length > 0) {
					await this.saleFinish(this.tempForSale);
					if (!this.saleFinishError) {
						this.$vs.notify({
							time: 1000,
							title: 'Продажа выполнена успешно!',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});
						this.$store.commit('wholesalePos/setIsReturn', false);
						await this.focusSearchBar();
					}
				} else {
					this.$vs.notify({
						title: 'Пожалуйста, добавьте продукт',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}
				await this.clearSearchBar();
				await this.focusSearchBar();
			} else if (status == 'draft') {
				/**
				 * SAVDONI FRONT ENDDA HISOB KITOBINI QILIB OXIRIDA BACK ENDGA YUBORADIGAN QILISH UCHUN
				 * QO'SHILDI BU COMMIT 12.05.2020 (BAXTIYOR ADDED FROM GLOBAL_TASHKENT BRANCH)
				 */
				await this.$store.commit('wholesalePos/editWholesaleLocally', this.tempForSale);
				// this.tempForSale.saleItems.forEach(el => {
				// 	el.isOptom = true
				// })
				// await this.editWholesale(this.tempForSale);

			} else if (status == 'suspended') {
				if(!this.converButtonClicked) {
					this.tempForSale.currencyId = null
					this.tempForSale.depCurrencyRate = null
					this.tempForSale.saleCurrencyRate = null
				}
				this.tempForSale.saleItems.forEach(el => {
					el.isOptom = true;
				})
				await this.suspendSale(this.tempForSale);
			} else if (status == 'forConvert') {
				if (this.suspendActive) {
					this.tempForSale.id = this.currentSuspendId;
					this.tempForSale.saleItems.forEach(el => {
						el.isOptom = true
					})
					await this.convertCurrency(this.tempForSale);
					this.converButtonClicked = true
				} else {
					this.tempForSale.saleItems.forEach(el => {
						el.isOptom = true
					})
					await this.convertCurrency(this.tempForSale);
					this.converButtonClicked = true
				}
			}
		},
		makeCurrentDateTime(forMethod) {
			let now = new Date();
			let year = now.getFullYear();
			let month = now.getMonth() + 1;
			let day = now.getDate();
			let hour = now.getHours();
			let minute = now.getMinutes();
			let second = now.getSeconds();
			if (month.toString().length == 1) {
				month = '0' + month;
			}
			if (day.toString().length == 1) {
				day = '0' + day;
			}
			if (hour.toString().length == 1) {
				hour = '0' + hour;
			}
			if (minute.toString().length == 1) {
				minute = '0' + minute;
			}
			if (second.toString().length == 1) {
				second = '0' + second;
			}
			if (forMethod == 'savePos') {
				return month + '-' + day + '-' + year;
			}
			this.dateTime = year + '/' + month + '/' + day + ' ' + hour + ':' + minute + ':' + second;
		},
		cancelClicked() {
			if (this.currentSuspendId) {
				let fromCancelButton = true;
				this.updateDraft(this.currentSuspendSale, fromCancelButton);
			} else {
				this.discountOptom = null;
				this.currencyCheckbox = false;
				this.saleCurrency = null;
				this.saleCurrencyOld = null;
				this.converButtonClicked = false;
				this.saleCurrencyRate = null;
				this.depCurrencyRate = null;
				this.contrAgent = null;
				this.categoryOptions.value = null
				this.$store.commit('wholesalePos/resetState');
				const emptyObject = {};
				this.emptyObjectStore(emptyObject);
				this.focusSearchBar();
				this.clearSearchBar();
			}
		},
		async checkPriceDifference(selectedIndex) {
			let equalItems = this.getItems.filter(el => el.itemId == this.getItems[selectedIndex].itemId);
			let foundDifference = false;
			if (equalItems.length > 1) {
				equalItems.forEach(el => {
					if(el.priceWholesale != this.getItems[selectedIndex].priceWholesale) {
						foundDifference = true;
					}
				})
			}
			return foundDifference;
		},
		async selectedHandler(selectedIndex) {
			this.currentIndex = selectedIndex;
			if (this.getItems.length > 0) {
				// let equalItems = this.getItems.filter(el => el.itemId == this.getItems[selectedIndex].itemId);
				// let foundDifference = false;
				// if (equalItems.length > 1) {
				// 	equalItems.forEach(el => {
				// 		if(el.priceWholesale != this.getItems[selectedIndex].priceWholesale) {
				// 			foundDifference = true;
				// 		}
				// 	})
				// 	if (foundDifference) {
				// 		this.$vs.notify({
				// 			title: 'Этот товар имеет разные цены',
				// 			text: 'Пожалуйста, выровняйте цены',
				// 			time: 3500,
				// 			color: 'warning',
				// 			icon: 'close',
				// 			position: 'top-right'
				// 		});
				// 		return 0;
				// 	}
				// }
				let foundDifferentPrice = await this.checkPriceDifference(selectedIndex);
				// if (foundDifferentPrice) {
				// 	this.$vs.notify({
				// 		title: 'Этот товар имеет разные цены',
				// 		text: 'Пожалуйста, выровняйте цены',
				// 		time: 3500,
				// 		color: 'warning',
				// 		icon: 'close',
				// 		position: 'top-right'
				// 	});
				// 	return 0;
				// }
				if ((this.getItems[selectedIndex].qty > 0 && this.getItems[selectedIndex].priceWholesale > 0) || this.isReturn) {
					await this.addToCart(this.getItems[selectedIndex]);
				}
			} else {
				/*await this.hideSearchResult();
					await this.clearSearchBar();*/
			}
		},
		escapeClicked() {
			this.hideSearchResult();
			this.clearSearchBar();
			this.focusSearchBar();
		},
		async setCount(event, index) {
			let inputCount = parseFloat(event)
			if (!inputCount) {
				let payload = {};
				payload.index = index;
				payload.newCount = 1;
				await this.setIncrementValue(payload);
			} else {
				if (inputCount > 0) {
					let payload = {};
					payload.index = index;
					payload.newCount = inputCount;
					await this.setIncrementValue(payload);
				} else {
					let payload = {};
					payload.index = index;
					payload.newCount = 1;
					await this.setIncrementValue(payload);
				}
			}
			await this.savePos('draft');
		},
		async setItemWeight(event, index) {
			let inputWeight = parseFloat(event);
			if (!inputWeight) {
				let payload = {};
				payload.index = index;
				payload.newWeight = 0;
				await this.setItemWeightAction(payload);
			} else {
				if (inputWeight > 0) {
					let payload = {};
					payload.index = index;
					payload.newWeight = inputWeight;
					await this.setItemWeightAction(payload);
				} else {
					let payload = {};
					payload.index = index;
					payload.newWeight = 0;
					await this.setItemWeightAction(payload);
				}
			}
		},
		async addToCart(item) {
			this.hideSearchResult();
			this.clearSearchBar();
			this.focusSearchBar();
			await this.addToCartAction(item);
			this.barcodeScanned = false;
			await this.savePos('draft');
		},
		async deleteFromCart(index) {
			await this.deleteFromCartAction(index);
			await this.savePos('draft');
			this.focusSearchBar();
		},
		async decreaseQty(dataDecrease) {
			this.isCountBtnsDisabled = true;
			await this.decreaseCount(dataDecrease);
			await this.savePos('draft');
			this.isCountBtnsDisabled = false;
			this.focusSearchBar();
		},
		async increaseQty(dataindex) {
			this.isCountBtnsDisabled = true;
			await this.increaseCount(dataindex);
			await this.savePos('draft');
			this.isCountBtnsDisabled = false;
			this.focusSearchBar();
		},
		async filterChanged(newVal) {
			this.currentIndex = 0;
			if (this.$refs.withKeyboardControl) {
				this.$refs.withKeyboardControl.selectedIndex = 0;
			}
			if (newVal.length >= 2) {
				/** BU RESULT TOPILMASA SEARCHINPUT VALUENI SELECT QILIB QO'YISHNI TO'G'IRLASH UCHUN YOZILGAN **/
				clearTimeout(this.timeout);
				let vm = this;
				this.timeout = setTimeout(async function() {
					vm.showSearchResult();
					if (!vm.barcodeScanned) {
						// await vm.fetchWholesaleSearchItems(newVal);
						await vm.getItemsForPos(newVal);
					}
					// await vm.showSearchResult();
				}, 5);
				// this.showSearchResult();
				// await this.getItemsForPos(newVal);
				/*if (this.getItems.length == 1) {
						this.hideSearchResult();
						await this.selectedHandler(0)
					} else {
						this.showSearchResult();
					}*/
			} else {
				this.hideSearchResult();
			}

		},
		async posBarcodeScanned(barcodeNumber) {
			if (barcodeNumber.length > 3) {
				this.barcodeScanned = true;
				if (this.getItems.length <= 0) {
					await this.getItemsForPos(barcodeNumber);
					// await this.fetchWholesaleSearchItems(barcodeNumber);
				}
				let foundDifferentPrice = await this.checkPriceDifference(0);
				if (foundDifferentPrice) {
					this.$vs.notify({
						title: 'Этот товар имеет разные цены',
						text: 'Пожалуйста, выровняйте цены',
						time: 3500,
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
					await this.setBarcodeScanned(false);
					return 0;
				}
				if (this.getItems.length > 0) {
					if (this.getItems[0].qty > 0 || this.isReturn) {
						await this.addToCart(this.getItems[0]);
					}
				} else {
					await this.setBarcodeScanned(false);
				}
			}
		},
		setBarcodeScanned(boolean) {
			this.$refs.searchBar.focus();
			this.$refs.searchBar.select();
			this.barcodeScanned = boolean;
		},
		showSearchResult() {
			this.currentIndex = 0;
			if (this.$refs.withKeyboardControl) {
				this.$refs.withKeyboardControl.addKeyHandler();
			}
			this.$refs.searchResult.style.display = 'block'
		},
		hideSearchResult() {
			if (this.$refs.withKeyboardControl) {
				this.$refs.withKeyboardControl.removeKeyHandler();
			}
			this.$refs.searchResult ? this.$refs.searchResult.style.display = 'none' : ''
			this.$store.commit('wholesalePos/setPosItems', []);
		},
		focusSearchBar(fromChild = '') {
			if (this.$refs.searchBar !== undefined) {
				this.$refs.searchBar.focus()
				this.$refs.searchBar.$el.value = '';
			}
			if (fromChild == 'clientForPos') {
				this.clearSearchBar();
			}
		},
		clearSearchBar() {
			this.posSearchValue = '';
			this.$refs.searchBar.$el.value = '';
		},
		searchBarRefresh() {
			this.clearSearchBar();
			this.focusSearchBar();
		},

		async showModalIfSessionNotStarted() {
			if (this.errorOccur) {
				this.$refs.sessionStart.show()
			}
		},
		async sessionStartOk() {
			this.$refs.sessionStart.hide();
			await this.startSessionToDep(localStorage.getItem('dep_id'))
			await this.createPosDraft(this.tempForSale);
			this.setErrorOccurNotHappen()
		},

		focusEnterCode() {
			this.$refs.enterConfirmCode.focus();
		}
	},

	/** --CREATED HOOK-- **/
	async created() {
		// THIS PAYLOAD IS FOR GETTING BOOKING DOCS BY USER DEPARTMENT ID
		this.payloadForList.depIds.push(parseInt(this.userDepId));

		this.$barcodeScanner.init(this.posBarcodeScanned);
		await this.getContragentsForWholesale();

		if (this.mode === 'create') {
			await this.$store.commit('wholesalePos/resetState');
			await this.$store.commit('wholesalePos/resetSuspendId');

			await this.createPosDraft(this.tempForSale);
			// if (this.errorOccur) {
			// 	this.sessionStartOk()
			// }
			this.showModalIfSessionNotStarted()
		} else {
			this.changeSuspendActive(true);
		}
	},

	/** --MOUNTED HOOK-- **/
	mounted() {
		this.setColumns();
		this.focusSearchBar();
		this.cashboxNumber = localStorage.getItem('cash_number');
		this.getLatestSuspends();
	},

	/** --BEFORE DESTROY HOOK-- **/
	beforeDestroy() {
		clearInterval(this.$options.interval);
	},

	/** ROUTE GUARD **/
	beforeRouteEnter(to, from, next) {
		let cashboxnumber = window.localStorage.getItem('cashboxnumber');
		if (cashboxnumber) {
			next()
		} else {
			next('/point-of-sale/beforePos')
		}
	}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style scoped lang="scss">
.container {
	padding: 0;
}

// @import url('https://fonts.googleapis.com/css?family=Inconsolata');

.print {
	display: none;
}

@media print {
	// @page {
	// 	size: portrait;
	// }
	.hidden-print {
		display: none;
	}

	.print {
		color: #000000;
		display: block;
	}

	.card {
		box-shadow: none;
	}
}

.posCustomModalHeader {
	display: flex;
	width: 100%;
	justify-content: space-between;

	.close {
		font-size: 14px;
	}
}

p {
	margin-bottom: 0;
}

.foundProduct {
	&.disabled {
		background-color: #eeeeee;
	}

	&.selected {
		background-color: #ccc;
	}
}

.input-group-text#for-barcode {
	padding: 0;

	.input-group-addon.barcode-refresh {
		padding: 0.575rem 0.75rem;

		&:active {
			border: .5px solid #dddddd;
		}
	}
}

.lastElemet {
	display: flex;
	justify-content: flex-end;
	margin-right: 25px;
}

#searchResult {
	display: none;
	position: absolute;
	top: 100%;
	width: 92.25%;
	border: 1px solid #c5c5c5;
	left: 4.05%;
	background: #ffffff;
	z-index: 101;
	max-height: 29rem;
	min-height: 80px;
	overflow-x: auto;

	.posItemImage {
		width: 40px;
		height: auto;
		object-fit: cover;
		margin: 0 10px 0 5px;
	}

	.foundProduct {
		padding: 10px;
		cursor: pointer;

		&:hover {
			background: #ccc;
		}

		.productName {
			padding-right: 1rem;
			font-size: 12px;
		}

		.productPrice {
			font-size: 13px;
			width: 32%;
		}

		.productBreadcrumb {
			font-size: 12px;
			color: #888;
		}
	}
}

@media (min-width: 1624px) {
	#searchResult {
		width: 93.495%;
		left: 3.41%;
	}
}

#posProducts {
	margin-top: 20px;
	max-height: 24rem;
	overflow-x: auto;
}

#overallAndButtons {
	background: white;
	.posFooterTable {
		.d-inline-table {
			display: inline-table;
		}
	}

	#posButtons {
		padding-top: 10px;
		padding-bottom: 10px;
		display: flex;
		justify-content: space-between;
	}
}

.alignedLeft {
	text-align: left;
}

.alignedRight {
	text-align: right;
}

.alignedCenter {
	text-align: center;
}

#posCheckClone {
	width: 100mm;
	background: white;
	padding: 10px;
	font-family: monospace;
	font-size: 14px;
	font-weight: bold;
	color: #000000 !important;

	#depNameClone {
		font-size: 18px;
	}

	.bottom-bordered {
		padding-bottom: 2px;
		border-bottom: .5px dashed #444;
	}

	table {
		width: 100%;
	}

	.returnItemBordered {
		border: .5px dotted black;
	}

	td, th {
		border: none;
		font-size: 12px;
		padding: 2px;
		color: #000000;
		vertical-align: top !important;
	}

	.table {
		td, th {
			vertical-align: top;
		}
	}

	.posCheckTotal {
		table {
			td {
				font-weight: bold;
				font-size: 14px;
			}
		}
	}
	.posCheckTotalB {
		table {
			td {
				font-weight: bold;
				font-size:12px;
			}
		}
	}
	.posThanks {
		p {
			text-align: center;
			font-weight: bold;
			font-size: 14px;
		}
	}
}

/*RIGHT SIDE STYLE*/
.header-sidebar {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	width: 100%;
}

.header-sidebar h4 {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
}

.header-sidebar h4>button {
	margin-left: 10px;
}

.footer-sidebar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
}

.row {
	margin-left: -18px;
}

.footer-sidebar>button {
	border: 0px solid rgba(0, 0, 0, 0) !important;
	border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
	border-radius: 0px !important;
}

.forHeader {
	/*min-height: 337px;*/
	margin-bottom: 5px;
}

.forfooter {
	min-height: 133px;
}

.card-header .nav-tabs .nav-link {
	padding: 0px;
}

.tabs.mytabs .nav-tabs .nav-link.active {
	background-color: #aabbcc !important;
}

.card-body {
	padding: 10px;
}

.cardBodyClass {
	position: relative;

	#returnComponentButton, #bookingDocsButton {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		margin: 10px;

		button {
			width: 100%;
		}
	}
	#bookingDocsButton {
		top: -20px;
	}
}

.card-header .nav-tabs .nav-link {
	padding: 0 0 0 0;
}

.generalTableClassForSuspend {
	max-height: 9rem;
	overflow-y: scroll;
	overflow-x: scroll;
}

@media (min-width: 1620px) {
	.generalTableClassForSuspend {
		max-height: 13rem;
	}
}

/*.mytabs {
		.nav-tabs {
			.nav-item {
				.nav-link.customTabLink {
					padding: 5px;
				}
			}
		}
	}*/
.customTabLink {
	padding: 5px;
}

.takeMinHeight {
	min-height: 39.1% !important;
	transition: min-height 0.25s ease-in !important;
}

.saveButton {
	justify-content: center;
	display: flex;
	align-items: center;
}

.posSessionButtons {
	display: flex;
	align-items: center;
	justify-content: flex-end;

	button {
		padding: 0 6px 1px;
		font-size: 12px;
		margin-right: 5px;
		line-height: 1.4;
	}
}

.clientTitle {
	font-weight: bold;
	font-size: 16px;
}

.posClientWholesale {
	min-height: 60%;
}

.form-group {
	margin-bottom: 0;
}

.posContainer {
	margin-top: 10px;
}

.posRow {
	margin-left: -35px;
	margin-right: -35px;
}

// .multiselect--disabled {
// 	background: transparent;
// }
a.suspendEditButton {
	&.disabled{
		pointer-events: none;
	}
}

// THIS STYLES ARE FOR BOOKING MODAL LOADING STATE
.table-wrapper {
	position: relative;
	padding: 5px;
	&#posProducts {
		padding: 0;
	}
}

.spinner-wrapper {
	position: absolute;
	background: rgba(32, 28, 32, 0.49);
	left: 0;
	right: 0;
	text-align: center;
	top: 0;
	bottom: 0;
	padding-top: 35px;
	z-index: 5;
}
</style>
